import { Routes } from '@angular/router';
import { AuthGuard } from '@i7/shared';

export const indRoutes: Routes = [
  {
    path: "ordem-producao",
    loadChildren: () =>
      import("../pages/ind/ordem-producao/ordem-producao-routing.module").then(
        (module) => module.OrdemProducaoRoutingModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'indice',
    loadChildren: () =>
      import('../pages/bas/indice/indice.module').then(
        (module) => module.IndiceModule
      ),
    canActivate: [AuthGuard],
  }
];
